import { render, staticRenderFns } from "./KeywordMessage.vue?vue&type=template&id=59b38828&"
import script from "./KeywordMessage.vue?vue&type=script&lang=js&"
export * from "./KeywordMessage.vue?vue&type=script&lang=js&"
import style0 from "./KeywordMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports